{
  "remove": "Kaldır"
}
